// De filterkolom werkt zonder JavaScript: het is een gewoon formulier met een
// verstuurknop. Dit bestand maakt het prettiger: aankruisen verstuurt meteen,
// er is een zoekveldje per lijst, de bouwjaarschuif zet twee waarden tegelijk,
// en op mobiel schuift de kolom als lade naar binnen.

(function () {
  const kolom = document.querySelector('[data-rv-kolom]');
  const form = document.querySelector('[data-rv-form]');
  if (!form) return;

  const verstuur = () => {
    // Lege velden horen niet in de URL: die maken hem lang en lelijk.
    for (const veld of form.querySelectorAll('input[type="number"]')) {
      if (veld.value === '') veld.disabled = true;
    }
    form.requestSubmit ? form.requestSubmit() : form.submit();
  };

  // ---------------------------------------------------------- aankruisen

  for (const vakje of form.querySelectorAll('input[type="checkbox"]')) {
    vakje.addEventListener('change', verstuur);
  }

  for (const veld of form.querySelectorAll('input[type="number"]')) {
    veld.addEventListener('change', verstuur);
    veld.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); verstuur(); }
    });
  }

  // ------------------------------------------------------------- zoeken

  for (const zoek of form.querySelectorAll('[data-rv-zoek]')) {
    const lijst = form.querySelector('[data-rv-lijst="' + zoek.dataset.rvZoek + '"]');
    if (!lijst) continue;

    zoek.addEventListener('input', () => {
      const term = zoek.value.trim().toLowerCase();
      const meer = form.querySelector('[data-rv-meer="' + zoek.dataset.rvZoek + '"]');

      for (const keuze of lijst.querySelectorAll('.rv-keuze')) {
        const naam = keuze.dataset.naam || '';
        if (term === '') {
          // Terug naar de ingeklapte stand: alleen de eerste zes.
          const extra = keuze.dataset.rvExtra === 'true';
          keuze.hidden = extra && !keuze.querySelector('input').checked;
        } else {
          keuze.hidden = !naam.includes(term);
        }
      }
      if (meer) meer.hidden = term !== '';
    });
  }

  // -------------------------------------------------------- meer tonen

  for (const knop of form.querySelectorAll('[data-rv-meer]')) {
    knop.addEventListener('click', () => {
      const lijst = form.querySelector('[data-rv-lijst="' + knop.dataset.rvMeer + '"]');
      if (!lijst) return;
      for (const keuze of lijst.querySelectorAll('[data-rv-extra="true"]')) keuze.hidden = false;
      knop.hidden = true;
    });
  }

  // ---------------------------------------------------------- bouwjaar

  const schuif = form.querySelector('[data-rv-jaar]');
  if (schuif) {
    const van = schuif.querySelector('[data-rv-jaar-van]');
    const tot = schuif.querySelector('[data-rv-jaar-tot]');
    const balk = schuif.querySelector('[data-rv-jaar-balk]');
    const tekst = form.querySelector('[data-rv-jaar-tekst]');
    const vakjes = [...form.querySelectorAll('[data-rv-jaar-vakjes] input')];
    const min = Number(schuif.dataset.min);
    const max = Number(schuif.dataset.max);
    const startVan = van.value;
    const startTot = tot.value;

    const grenzen = () => [
      Math.min(Number(van.value), Number(tot.value)),
      Math.max(Number(van.value), Number(tot.value)),
    ];

    const teken = () => {
      const [a, b] = grenzen();
      const links = ((a - min) / (max - min)) * 100;
      const rechts = ((b - min) / (max - min)) * 100;
      balk.style.left = links + '%';
      balk.style.width = rechts - links + '%';
      if (tekst) tekst.textContent = a + ' t/m ' + b;
    };

    // Zoek je artikelen die op 1974 passen, dan is dat: begonnen in 1974 of
    // eerder, en doorgelopen tot 1974 of later. Shopify kent alleen losse
    // jaartallen, dus vinken we aan beide kanten alles aan wat daaraan voldoet.
    const zetVakjes = () => {
      const [a, b] = grenzen();
      const heel = a === min && b === max;
      for (const vakje of vakjes) {
        const jaar = Number(vakje.dataset.jaar);
        vakje.checked = heel ? false : (vakje.dataset.kant === 'van' ? jaar <= b : jaar >= a);
      }
    };

    const zetGoed = () => {
      if (Number(van.value) > Number(tot.value)) {
        const h = van.value;
        van.value = tot.value;
        tot.value = h;
      }
      teken();
    };

    van.addEventListener('input', zetGoed);
    tot.addEventListener('input', zetGoed);

    const losgelaten = () => {
      if (van.value === startVan && tot.value === startTot) return;
      zetVakjes();
      verstuur();
    };
    van.addEventListener('change', losgelaten);
    tot.addEventListener('change', losgelaten);

    // Ook bij een klik elders in de kolom moet de schuifstand meegaan.
    form.addEventListener('submit', zetVakjes);

    teken();
  }

  // ------------------------------------------------------------- de lade

  const scherm = document.querySelector('[data-rv-scherm]');
  const open = (aan) => {
    if (kolom) kolom.dataset.open = aan ? 'true' : 'false';
    if (scherm) scherm.dataset.open = aan ? 'true' : 'false';
    document.body.style.overflow = aan ? 'hidden' : '';
  };

  for (const knop of document.querySelectorAll('[data-rv-lade-open]')) {
    knop.addEventListener('click', () => open(true));
  }
  for (const knop of document.querySelectorAll('[data-rv-lade-sluit]')) {
    knop.addEventListener('click', () => open(false));
  }
  if (scherm) scherm.addEventListener('click', () => open(false));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') open(false);
  });

  // ---------------------------------------------------------- sorteren

  const sorteer = document.querySelector('[data-rv-sorteer]');
  if (sorteer) sorteer.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sorteer.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
})();
